import React, { ReactNode, useEffect, useRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { BrowserRouter as WrappedBrowserRouter, BrowserRouterProps, useLocation } from 'react-router-dom';

import { useTrackEventsService } from 'components/Services/Analytics/useTrackEventsService';

interface BrowserRouterWrapperProps extends BrowserRouterProps {
  disableTracking?: boolean;
  children?: ReactNode;
}

const TrackingWrapper = ({ basename, disableTracking, children }: BrowserRouterWrapperProps) => {
  const location = useLocation();
  const currentPathName = useRef(location.pathname);

  const { trackPageViewed } = useTrackEventsService();

  useEffect(() => {
    const newPathName = location.pathname;

    if (currentPathName.current !== newPathName && !disableTracking) {
      currentPathName.current = newPathName;
      trackPageViewed(`/${basename}${newPathName}`);
    }
  }, [location.pathname, trackPageViewed, basename, disableTracking]);

  return <>{children}</>;
};

const BrowserRouter = ({
  children,
  basename = '',
  disableTracking = false,
  ...restProps
}: BrowserRouterWrapperProps) => (
  <WrappedBrowserRouter basename={basename} {...restProps}>
    {disableTracking ? children : <TrackingWrapper basename={basename}>{children}</TrackingWrapper>}
  </WrappedBrowserRouter>
);

export default BrowserRouter;
